import { sendToURL } from 'amkit3-modules/utils/ajax'
import { STATISTIC_YYGAME } from 'amkit3-modules/utils/services/urls'

export const load = (code, ati, adid, mid, session_id) => {
  sendToURL(STATISTIC_YYGAME, {
    act: '/event',
    dty: 'pas',
    pro: 'resource',
    cha: 'flash',
    eid: 'load/' + code,
    ati,
    adid,
    mid,
    session_id,
  })
}

export const click = (code, ati, adid, mid, session_id) => {
  sendToURL(STATISTIC_YYGAME, {
    act: '/event',
    dty: 'pas',
    pro: 'resource',
    cha: 'flash',
    eid: 'click/' + code,
    ati,
    adid,
    mid,
    session_id,
  })
}

export default {
  load,
  click,
}
